export default __webpack_public_path__ + "static/media/bessen-triplets.cdfee33b.png";